import { useEffect } from 'react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { getTodayDateString } from '../utils/noteDateUtils'
import useLoginStore from '@/store/LoginStore'
import { useTimezone } from '@/store/UserPreferencesStore'

export const Route = createFileRoute(
  '/_AppWrapper/_AppLayout/$workspaceSlug/notes/',
)({
  component: NotesRedirectPage,
})

/**
 * Redirects to today's daily note when navigating to /notes
 */
function NotesRedirectPage() {
  const navigate = useNavigate()
  const workspaceSlug = useLoginStore((state) => state.workspaceSlug)
  const timezone = useTimezone()

  useEffect(() => {
    if (workspaceSlug) {
      const today = getTodayDateString(timezone)
      navigate({
        to: `/${workspaceSlug}/notes/daily/${today}`,
        replace: true,
      })
    }
  }, [navigate, workspaceSlug, timezone])

  return null
}
